export var StorageEndpoints;
(function (StorageEndpoints) {
    // Flow types for storage
    let OfframpHandlerType;
    (function (OfframpHandlerType) {
        OfframpHandlerType["EVM_TO_STELLAR"] = "evm-to-stellar";
        OfframpHandlerType["ASSETHUB_TO_STELLAR"] = "assethub-to-stellar";
        OfframpHandlerType["EVM_TO_BRLA"] = "evm-to-brla";
        OfframpHandlerType["ASSETHUB_TO_BRLA"] = "assethub-to-brla";
    })(OfframpHandlerType = StorageEndpoints.OfframpHandlerType || (StorageEndpoints.OfframpHandlerType = {}));
    let OnrampHandlerType;
    (function (OnrampHandlerType) {
        OnrampHandlerType["BRLA_TO_EVM"] = "brla-to-evm";
        OnrampHandlerType["BRLA_TO_ASSETHUB"] = "brla-to-assethub";
    })(OnrampHandlerType = StorageEndpoints.OnrampHandlerType || (StorageEndpoints.OnrampHandlerType = {}));
})(StorageEndpoints || (StorageEndpoints = {}));
